module.exports = __webpack_public_path__ + "static/media/development-min.8a304ba2.webp";